import { useTour } from 'app-context/tourContext/TourContext';
import TourModal from 'component/hoc/tour-modal/TourModal';
import AddTermsConditions from 'component/organism/terms-conditions/AddTermsConditions';
import { termsConditionsToast } from 'helpers/toastMessages';
import { companyEndpoints, settingsEndpoints } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';
import { usePost } from 'hooks/usePost';
import SettingsHeader from 'pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader';
import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';

const TermsAndConditions = () => {
  const ref = useRef(null);
  const { id } = useParams();
  const { showModal } = useTour();
  const { mutate: saveTerms, isPEnding } = usePost({
    onSuccessToast: termsConditionsToast.save,
    toastType: 'add',
  });
  const {
    data: termsConditions,
    isFetching,
    refetch,
  } = useFetch(
    ['termsConditions', id],
    companyEndpoints.getChatSettings,
    { enabled: true },
    { botId: id }
  );

  const { data: botData } = useFetch(
    ['bot-data', id],
    settingsEndpoints?.getBotById(id),
    {
      enabled: true,
    }
  );

  const handleSave = async () => {
    await ref.current.submitForm();

    const formIsValid = ref.current?.isValid;
    if (formIsValid) {
      saveTerms(
        {
          url: companyEndpoints.setCompanyChatSettings(),
          data: {
            ...ref?.current?.values,
            botId: id,
            termsFrequency: parseInt(ref?.current?.values?.termsFrequency),
          },
        },
        {
          onSuccess: () => {
            refetch();
          },
        }
      );
    }
  };
  return (
    <>
      <SettingsHeader
        title='Terms and Conditions'
        rightButtons={[
          {
            label: 'Save',
            type: 'save',
            func: handleSave,
            isLoading: isPEnding,
          },
        ]}
      />

      <AddTermsConditions
        ref={ref}
        id={id}
        termsConditions={termsConditions}
        isFetching={isFetching}
        botData={botData?.data}
      />
      {showModal && <TourModal />}
    </>
  );
};

export default TermsAndConditions;
